import { render, staticRenderFns } from "./disabled-security-settings.vue?vue&type=template&id=71efbac1"
import script from "./disabled-security-settings.vue?vue&type=script&lang=js"
export * from "./disabled-security-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports